import React from 'react';
import { Box } from '@mui/material';
import { CameraMeasurementPanel } from './CameraMeasurementPanel';
import {
  SCAN_MEASUREMENT_BASIS_TITLE,
  SCAN_MEASUREMENT_UNAVAILABLE,
} from '../../domain/cameraMeasurement/cameraMeasurementPresentation';
import {
  resolveScanMeasurementSource,
  type ScanMeasurementSource,
} from '../../domain/cameraMeasurement/scanMeasurementIdentity';
import type { CameraActivityMeasurementResponse } from '../../services/cameraActivityMeasurementApi';

const colors = {
  ink: '#0f172a',
  ink3: '#7d8798',
  line: '#e3e8ef',
  greySoft: '#f8fafc',
};

export function ScanCameraMeasurementBasis({
  source,
  override = null,
  defaultExpanded,
}: {
  source: ScanMeasurementSource;
  override?: CameraActivityMeasurementResponse | null;
  defaultExpanded?: boolean;
}) {
  const resolved = resolveScanMeasurementSource(source);
  if (!resolved.ok) {
    return (
      <Box
        component="section"
        data-testid="scan-measurement-basis"
        data-unavailable-reason={resolved.reason}
        aria-label={SCAN_MEASUREMENT_BASIS_TITLE}
        sx={{
          bgcolor: colors.greySoft,
          border: `1px solid ${colors.line}`,
          borderRadius: '8px',
          p: '10px 12px',
        }}
      >
        <Box component="h3" sx={{ m: 0, fontSize: 11, fontWeight: 750, color: colors.ink }}>
          {SCAN_MEASUREMENT_BASIS_TITLE}
        </Box>
        <Box data-testid="scan-measurement-basis-unavailable" sx={{ fontSize: 11, color: colors.ink3, mt: '6px' }}>
          {SCAN_MEASUREMENT_UNAVAILABLE}
        </Box>
      </Box>
    );
  }
  return (
    <CameraMeasurementPanel
      presentation="scan-context"
      siteId={resolved.siteId}
      deviceId={resolved.deviceId}
      cameraId={resolved.cameraId}
      zoneId={resolved.zoneId}
      zoneName={resolved.zoneName}
      zoneVersion={resolved.zoneVersion}
      windowStart={resolved.windowStart}
      windowEnd={resolved.windowEnd}
      signed={resolved.signed}
      defaultScope={resolved.zoneId ? 'ZONE' : 'CAMERA'}
      override={override}
      defaultExpanded={defaultExpanded}
    />
  );
}

export default ScanCameraMeasurementBasis;
